export const MainRoles = {
    GlobalAdmin: 'GlobalAdmin',
    EnPowerAdmin: 'EnPowerAdmin',
    EnPowerUser: 'EnPowerUser',
    EnFactsAdmin: 'EnFactsAdmin',
    EnFactsUser: 'EnFactsUser',
    DeletedUser: 'DeletedUser',
    EnCountMobileUser: 'EnCountMobileUser',
    BlockedUser: 'BlockedUser',
};
export const AdditionalRoles = {
    LicenseManager: 'LicenseManager',
    Developer: 'Developer',
    EnCountAdmin: 'EnCountAdmin',
    EnFactsAreaAdmin: 'EnFactsAreaAdmin',
};
